import { AddEmployee } from './AddEmployee.main';

export { AddEmployee };
